import React from 'react'

export const FormMessageError = ({ message }) => {
  return (
    <span className="FormMessageError">
      { message }
    </span>
  )
}
